<template>
  <div class="-aspect-ratios">
    <div
      v-for="(ar, i) in boxes"
      :key="i"
      class="-aspect-ratio"
      :class="boxes[i].class"
      @click="selectAspectRatio(ar.key)"
      :title="`${ar.friendlyName} ${ar.friendlyVal}`"
    >
      <div class="-box" :style="boxes[i].style"></div>
      <div class="-friendly-name">
        {{ ar.friendlyName }}
        <div class="-friendly-val">{{ ar.friendlyVal }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    aspectRatios: {
      type: Object,
      required: true,
    },
    defaultAspectRatio: {
      type: String,
    },
  },
  data() {
    return {
      selectedAspectRatioKey: null,
    };
  },
  computed: {
    boxes() {
      const height = 45; // percent
      return this.computedAspectRatios.map(([key, value]) => ({
        key,
        ...value,
        style: {
          width: height * value.ratio + '%',
          height: height + '%',
        },
        class: {
          '-selected': this.selectedAspectRatioKey === key,
        },
      }));
    },
    computedAspectRatios() {
      return Object.entries(this.aspectRatios).filter(([key]) => key !== 'ALL');
    },
  },
  methods: {
    selectAspectRatio(key) {
      this.$emit('select', key);
      this.selectedAspectRatioKey = key;
    },
  },

  watch: {
    computedAspectRatios: {
      handler() {
        this.selectAspectRatio(
          this.defaultAspectRatio || this.computedAspectRatios[0][0]
        );
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.-aspect-ratios {
  display: flex;
  transform: translateX(0);
  justify-content: center;
  // flex: 1;

  .-aspect-ratio {
    position: relative;
    flex-shrink: 0;
    flex-grow: 0;
    cursor: pointer;
    height: 80px;
    width: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;

    &:hover {
      background-color: rgba(0, 0, 0, 0.05);
    }

    &.-selected {
      .-friendly-name {
        color: #06a9f4;
        .-friendly-val {
          color: #06a9f4;
        }
      }
      .-box {
        border: 1px solid #06a9f4;
      }
    }

    .-box {
      position: absolute;
      top: 35%;
      left: 50%;
      transform: translate(-50%, -50%);
      border: 1px solid rgba(0, 0, 0, 0.75);
      &:after {
        content: '';
        display: block;
        padding-bottom: 100%;
      }
    }
    .-friendly-name {
      color: rgba(0, 0, 0, 0.75);
      --font-size: 12px;
      position: absolute;
      font-size: var(--font-size);
      bottom: 2px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .-friendly-val {
        font-size: calc(var(--font-size) - 2px);
        margin-top: -2px;
        color: rgba(0, 0, 0, 0.55);
      }
    }
  }
}
</style>
